import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import { Toast } from 'antd-mobile'
import callAPI from 'utils/callAPI'
import { showBuyerNotMatchAlert } from 'util'
import keyMirror from 'pkeymirror'
import { encrypt } from 'utils/rsa'
import { getAppSalt } from 'store/siteConfig'
import { getUUID } from 'utils'
import _ from 'lodash'

// ------------------------------------
// Constants
// ------------------------------------
export const PAYMENTS_CYBERSOURCE = keyMirror({
  GET_ORGTOKEN_REQUEST: null,
  GET_ORGTOKEN_SUCCESS: null,
  SUBMIT_REQUEST: null,
  SUBMIT_SUCCESS: null,
}, 'PAYMENTS_CYBERSOURCE')

// ------------------------------------
// Actions
// ------------------------------------
export function getOrgToken(data) {
  Toast.loading('', 0)

  return (dispatch, getState) => {
    const saltKey = getUUID()
    dispatch(getAppSalt(saltKey)).then((res) => {
      const { salt } = res.payload
      const { cvv, cardNo, expireDate, holderName, ...restData } = data
      restData.cvv = encrypt(cvv, salt)
      restData.expireDate = encrypt(expireDate, salt)
      restData.holderName = encrypt(holderName, salt)
      restData.cardNo = encrypt(cardNo.replace(/ /g, ''), salt)
      const maskCardNo = cardNo.replace(/ /g, '').replace(/^(\d{6})\d{6}(\d*)$/, '$1******$2')

      dispatch(
        callAPI({
          dispatch: dispatch,
          method: 'POST',
          header: {
            'Salt-Key': saltKey,
          },
          body: restData,
          endpoint: 'cgs/personal/u/cacheCardInfo',
          requestAction: PAYMENTS_CYBERSOURCE.GET_ORGTOKEN_REQUEST,
          successAction: PAYMENTS_CYBERSOURCE.GET_ORGTOKEN_SUCCESS,
          success: function(result) {
            dispatch(
              submit({
                orgToken: `${result.orgToken}|${maskCardNo}`,
                email: data.email,
                countryCode: result.countryCode,
                cardBrand: result.cardBrand,
              })
            )
          },
        })
      )
    })
  }
}

export function submit(data) {
  const token = sessionStorage.getItem('token')
  const iapChallenge = JSON.parse(sessionStorage.getItem('iapChallenge'))
  const payMethod = JSON.parse(sessionStorage.getItem('payMethod'))
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: {
          token,
          paymentMethodList: [Object.assign({}, payMethod, data)],
          iapChallenge,
          screenWidth: window.screen.width,
          screenHeight: window.screen.height,
          userAgent: navigator.userAgent
        },
        endpoint: 'cgs/cashdesk/u/pay',
        requestAction: PAYMENTS_CYBERSOURCE.SUBMIT_REQUEST,
        successAction: PAYMENTS_CYBERSOURCE.SUBMIT_SUCCESS,
        success: function(result) {
          if (!result.bankFormUrl) {
            return Toast.info(
              'Bank validate url get failed, please try again later!'
            )
          }
          if (_.startsWith(result.bankFormUrl, 'http')) {
            window.location.href = result.bankFormUrl
            return
          }
          document.open()
          document.write(result.bankFormUrl)
          document.close()
        },
        error: function(result) {
          if (result.head.code === '66054') {
            showBuyerNotMatchAlert(result)
          }
        },
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [PAYMENTS_CYBERSOURCE.GET_ORGTOKEN_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [PAYMENTS_CYBERSOURCE.GET_ORGTOKEN_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
  [PAYMENTS_CYBERSOURCE.SUBMIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [PAYMENTS_CYBERSOURCE.SUBMIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'paymentsCybersource',
    reducerMap: {
      paymentsCybersourceState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
